// extracted by mini-css-extract-plugin
export default {"issueTypeDot":"IssueTypeDot-module__issueTypeDot--o16vA"};